export const jointMeetingBodiesCube = {
    category: 'Meeting Bodies',
    description: 'Joint meeting bodies and their active status.',
    label: 'Joint Meeting Bodies',
    question: 'Which joint meeting bodies exist and which are still active?',
    bestFor: 'A simple inventory of joint sessions configured between multiple bodies — useful when scheduling combined meetings or auditing retired pairings.',
    tags: ['Joint Sessions', 'Status'],
    measures: {
        'joint_meeting_bodies.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'joint_meeting_bodies.name': { label: 'Name', type: 'string' },
        'joint_meeting_bodies.is_active': { label: 'Is Active', type: 'boolean' },
    },
    timeDimensions: {
        'joint_meeting_bodies.created_at': { label: 'Created At', type: 'date' },
        'joint_meeting_bodies.updated_at': { label: 'Updated At', type: 'date' },
    },
};
